import { render, staticRenderFns } from "./GeoInfo.vue?vue&type=template&id=60666098&scoped=true&"
import script from "./GeoInfo.vue?vue&type=script&lang=js&"
export * from "./GeoInfo.vue?vue&type=script&lang=js&"
import style0 from "./GeoInfo.vue?vue&type=style&index=0&id=60666098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60666098",
  null
  
)

export default component.exports